import { Typography, Box } from "@mui/material";

const TabPannelProject = (props) => {
  const { children, value, index, ...others } = props;
  return (
    <>
      <div
        role="tabpannel"
        hidden={value !== index}
        id={`tabpannel-${index}`}
        aria-labelledby={`sidebar-tab-${index}`}
        {...others}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    </>
  );
};
export default TabPannelProject;
